import { render, staticRenderFns } from "./CommentsContainer.vue?vue&type=template&id=68413562&scoped=true"
import script from "./CommentsContainer.vue?vue&type=script&lang=js"
export * from "./CommentsContainer.vue?vue&type=script&lang=js"
import style0 from "./CommentsContainer.vue?vue&type=style&index=0&id=68413562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68413562",
  null
  
)

export default component.exports